import Vue from "vue"
const ExpandInput = {
    bind: function (el) {
        const input = el.getElementsByTagName('input')[0]
        el.addEventListener('click',(e)=>{
          e.preventDefault();
        console.log("🚀 ~ input", input)
        console.log("🚀 ~ el", el)
        console.log("🚀 ~ e.target", e.target)
          // if(e.target===el){
         
            input.focus()
            // input.click()
          // }
        

        })
}
}



export default ExpandInput





// WEBPACK FOOTER //
// ./src/common/directives/expandInput.js